export enum Province {
  ON = "on",
  NL = "nl",
  PE = "pe",
  NS = "ns",
  NB = "nb",
  QC = "qc",
  MB = "mb",
  SK = "sk",
  AB = "ab",
  BC = "bc",
  YT = "yt",
  NT = "nt",
  NU = "nu"
}

export enum PageType {
  LOGIN = "login",
  ACTIVATE = "activate",
  ACCOUNT_SELECTION = "accounts"
}

export enum CTATypes {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  TERTIARY = "tertiary"
}

export enum Language {
  EN = "en",
  FR = "fr"
}

export enum ActivationPageState {
  ENTER_CODE,
  SUCCESS,
  ERROR,
  ACCOUNTSELECTION
}

export enum Subscription {
  subType = 'IPTV',
  status = 'Active',
}

export enum ErrorCode {
  CODE_ERROR = "400",
  TECH_ERROR = "500",
  SUBSCRIBERS_ONLY = "subscribersOnly",
  NO_RESPONSE = "204",
  PARTIAL_RESPONSE = "206",
}